import { IBiddingResponse } from "../../../model/base/response/bidding-response";
import { IBiddingStatusResponse } from "../../../model/base/response/bidding-status-response";
import { ICategoryPublicationResponse } from "../../../model/base/response/category-publication-response";
import { IModalityBiddingResponse } from "../../../model/base/response/modality-bidding-response";
import { IQuestionAnwserReponsae } from "../../../model/base/response/question-awnser-respons";
import { Pagination } from "../../../model/paginatiion";


export type BiddingState = {
  biddings: Pagination<IBiddingResponse>;
  modalities: IModalityBiddingResponse[];
  status: IBiddingStatusResponse[];
};

export enum ACTION_TYPES {
  loadingData = 'loadingData',
  setModality = 'setModality',
  setStatus = 'setStatus',
}

export const BiddingReducer = (state: BiddingState, action: any): BiddingState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.loadingData:
      return {
        ...state,
        biddings: payload,
      };
    case ACTION_TYPES.setModality:
      return {
        ...state,
        modalities: payload,
      };
    case ACTION_TYPES.setStatus:
      return {
        ...state,
        status: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}